<cerrix-video-player [url]="configuredUrl"></cerrix-video-player>
